var _style, _defs, _rect, _defs2, _rect2, _defs3, _rect3, _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 272 96",
    style: {
      enableBackground: "new 0 0 272 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st3{fill:#F9BD00;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#F9BD00;}\n\t.st5{fill:#231916;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#231916;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1.9,1.8l63.2,89.9c0.8,1,1.8,1.8,3.1,2.1h25.5L1.9,1.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.8746,
    y1: 47.8189,
    x2: 93.8465,
    y2: 47.8189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231916"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#C6000D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#ED7700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9BD00"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 1.8,
    className: "st0",
    width: 91.8,
    height: 92
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M26.8,58.5L2,93.8h0.2l45.6-26.6L42.1,59L42,58.9c-1.7-2.4-4.5-4-7.7-4C31.3,54.9,28.6,56.3,26.8,58.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.8916,
    y1: 83.8114,
    x2: 44.9857,
    y2: 64.9279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231916"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#C6000D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#F5AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 54.9,
    className: "st1",
    width: 45.8,
    height: 38.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M47.8,28.7l5.8,8.3l0,0.1c1.7,2.4,4.5,3.9,7.7,3.9c3,0,5.7-1.4,7.5-3.7l25-35.5L47.8,28.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.7578,
    y1: 34.1766,
    x2: 97.3826,
    y2: 7.298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#F5AA00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#C6000D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231916"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 1.8,
    className: "st2",
    width: 46,
    height: 39.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.9,1.8l-46,26.9L64.9,4.4c1.1-1.6,2.8-2.6,4.8-2.6H93.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.8,67.2L30.6,91.8c-0.8,1-1.8,1.7-3,2.1H2.3L47.8,67.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1.9,1.8H26c2,0,3.7,1,4.8,2.5l0,0.1l62.9,89.5h-0.1L1.9,1.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M127.8,49.6c0,4.9-3.1,8.6-9.1,8.6H98.3v-6.6h20.4c1.9,0,2.7-0.9,2.7-2.3c0-1.5-0.7-2.3-2.7-2.3h-11.8 c-5.4,0-8.9-3.5-8.9-8.4c0-4.8,3.3-8.3,9-8.3h19.6V37h-19.6c-1.5,0-2.2,0.7-2.2,2.1c0,1.3,0.7,2.1,2.2,2.1h11.8 C124.4,41.1,127.8,43.9,127.8,49.6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "189.4,51.6 189.4,58.2 165.4,58.2 165.4,30.3 172,30.3 172,51.6  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M212.6,31.9l15.8,26.3h-7.9l-3.9-6.5h-11.8l3.4-5.8h5l-3.9-6.5l-11.1,18.8h-7.6l15.8-26.3c0.6-1.1,1.6-2,3.1-2 C211.1,30,212,30.9,212.6,31.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "253.6,43.8 268.7,58.2 259.3,58.2 248.9,48.1 238.6,58.2 229.7,58.2 244.6,43.8 230.7,30.3 240,30.3  249.4,39.4 258.6,30.3 267.5,30.3  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.1,44L163.1,44c0,8-5.7,14.2-13.7,14.2h-6.3c-7.8,0-13.6-6.2-13.6-14.2c0-8.2,5.8-13.7,13.6-13.7h6.3 C157.4,30.3,163.1,35.9,163.1,44 M136.2,44.2c0,4.3,2.9,7.4,6.9,7.4h6.3c4.1,0,7.1-3.1,7.1-7.4c0-4.3-2.9-7.3-7.1-7.3h-6.3 C139.1,37,136.2,39.9,136.2,44.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.5,72.5c2.9,0,4.6-1.9,4.6-4.6c0-2.8-1.7-4.5-4.6-4.5h-8.8V76h2.2V65.7h6.7c1.5,0,2.5,0.9,2.5,2.4 c0,1.4-0.9,2.4-2.5,2.4h-5.1v2.1H199.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,73.8L211.2,73.8c-2.3,0-3.9-1.7-3.9-4.1c0-2.4,1.7-4.1,3.9-4.1h3.1c2.3,0,4,1.7,4,4.1 c0,2.4-1.6,4.1-4,4.1H211.2z M214.3,76c3.6,0,6.2-2.8,6.2-6.4c0-3.7-2.5-6.2-6.2-6.2h-3.1c-3.5,0-6.1,2.5-6.1,6.2 c0,3.7,2.6,6.4,6.1,6.4H214.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.3,75.5c0.2,0.5,0.7,0.7,1.1,0.7c0.5,0,0.9-0.2,1.1-0.7l6.5-12.1h-2.5l-5.1,9.7l-4.9-9.7H226l3.3,6.2 l-1.9,3.4l-5.1-9.7h-2.6l6.5,12.1c0.3,0.5,0.7,0.7,1.1,0.7c0.5,0,0.9-0.2,1.1-0.7l2-3.7L232.3,75.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M253.2,70.6L253.2,70.6v-1.8h-7v1.8H253.2z M253.7,76v-2.2h-9.1v-8.2h9.1v-2.2h-11.2V76H253.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M270,76l-3.8-3.8c1.6-0.6,2.6-2.1,2.6-4.2c0-2.8-1.7-4.6-4.6-4.6h-9V76h2.2V65.7h6.9c1.5,0,2.4,0.8,2.4,2.4 c0,1.6-0.8,2.5-2.4,2.5H259v1.9h4.7l3.2,3.5H270z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolax);
export default __webpack_public_path__ + "static/media/solax.3d552a9cfbecaa975eb389dc5b6e6478.svg";
export { ForwardRef as ReactComponent };